import {
  NgModule
} from '@angular/core';

import {
  SharedCommonModule
} from '../shared/common';

import {
  LoginLayoutComponent
} from './login-layout.component';

@NgModule({
  imports: [
    SharedCommonModule
  ],
  declarations: [
    LoginLayoutComponent
  ],
  providers: [],
  entryComponents: [],
})
export class LoginLayoutModule {
}
